import React, { useState } from "react";
export default function Chatbot() {
  const [messages, setMessages] = useState([
    { sender: "bot", text: "Welcome to the Norlake Masterbilt Technical Assistant! How can I help you?" }
  ]);
  const [input, setInput] = useState("");

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { sender: "user", text: input };
    setMessages([...messages, userMessage]);

    try {
      const response = await fetch("https://api.openai.com/v1/chat/completions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer YOUR_OPENAI_API_KEY`
        },
        body: JSON.stringify({
          model: "gpt-4",
          messages: [{ role: "user", content: input }]
        })
      });

      const data = await response.json();
      const botMessage = { sender: "bot", text: data.choices[0].message.content };

      setMessages([...messages, userMessage, botMessage]);

      // Send response to HeyGen for avatar speech
      speakWithAvatar(botMessage.text);

    } catch (error) {
      console.error("Error:", error);
    }

    setInput("");
  };

  const speakWithAvatar = (text) => {
    const heyGenApiKey = "YOUR_HEYGEN_API_KEY";
    fetch("https://api.heygen.com/speech", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${heyGenApiKey}` },
      body: JSON.stringify({ text, avatar: "Abrey" })
    })
    .then(response => response.json())
    .then(data => {
      if (data.audioUrl) {
        new Audio(data.audioUrl).play();
      }
    });
  };

  return (
    <div className="chat-container">
      <div className="chat-box">
        {messages.map((msg, index) => (
          <div key={index} className={`message ${msg.sender}`}>
            {msg.text}
          </div>
        ))}
      </div>
      <input
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Type your question..."
      />
      <button onClick={sendMessage}>Send</button>
    </div>
  );
}
